import Block from "../Block";
import "./BlockAnnouncement.css";
import Menu from "../Menu/Menu";
import useBlockCamera from "/src/features/editor/hook/block/useBlockCamera";
import imageAnnouncementPreview from "/src/features/editor/image/jump_preview.png";
import BlockLinkEnd from "../BlockLinkEnd/BlockLinkEnd";
import BlockChild from "../BlockChild/BlockChild";
// Component for create the block jump
function BlockAnnouncement({ name, x, y, object_id, data, lowVersion,children, type }) {

    const block = {
        name, x, y, id: object_id, imageLow: imageAnnouncementPreview, lowVersion, type, data, className: "announcement"
    }
    return (
        <Block {...block}>
            {!lowVersion &&
                <>
                    <BlockLinkEnd parent_block_id={object_id} className="announcement" style={{ left: "-15px", top: "60px", transform: "rotate(270deg)" }} />
                    <Menu className="announcement" id={object_id} />
                    <label className="block_announcement_title">{name}</label>
                    <div className="block_announcement_icon"></div>
                    <div className="announcement_innerblock">{data.message}</div>
                    <BlockChild className="announcement" style={{left: "185.5px", top: "-115px", transform: "rotate(270deg)"}} parent_block_id={object_id} object_id={children[0].object_id} zero={true}/>

                </>
            }

        </Block>
    )
}

export default BlockAnnouncement;
